import React, {Component} from 'react';

import './Search.css'


export default class Search extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: ""
    }
    this.setSearch = this.setSearch.bind(this)
  }

  componentDidMount () {
    if (this.props?.filterText)
      this.setState({filter: this.props.filterText})
  }
  componentDidUpdate(prevProps) {
    if (prevProps?.clear < this.props?.clear && this.state.filter.length > 0)
      this.setState({filter: ""})
  }
  async setSearch (e) {
    e.preventDefault();
    this.setState( {filter: e.target.value })
    if (this.props.onChange)
      this.props.onChange(e.target.value);
  }

  handleSearch = (e) => {
    e.preventDefault();
    if (this.props.onChange)
      this.props.onChange(this.state.filter);
  }

  render () {
    return(
      React.cloneElement(this.props.children, 
        {filter:this.state.filter, setSearch:this.setSearch, handleSearch:this.handleSearch})
    )
  };
}
